/** English text for checkout, order lookup, payment instructions and the email check. Each value is also its translation key. */
export const C = {
  cNotSold: 'That combination is not sold. Pick another term or connection count.',
  cNameEmail: 'Please add your name and email.',
  cHandle: 'Please add your {method} handle.',
  cAnswer: 'Please answer the adult content and trial questions.',
  cAge: 'Please confirm you are 18 or older to include adult content.',
  cRefund: 'Please accept the no-refund policy to send your order.',
  cRefCheck: 'Check the referral username, or clear it to order without one.',
  codeBad: "That code isn't recognised.",
  codeExpired: 'That code has expired.',
  codeUsed: 'That code has been used up.',
  codeNotFor: "That code doesn't apply to {plan}.",
  codeApplied: '{code} applied',
  codeCant: 'Could not check that code.',
  refBy: 'Referred by {name}',
  refCant: 'Could not check that username.',
  refType: 'Type your friend’s username.',
  refOwn: 'That’s your own username. Referrals have to come from a friend.',
  refNot: 'That username isn’t an active, paid account.',

  summoning: 'The summoning has begun.',
  yourCode: 'Your order code is',
  trialReach: "We'll reach you on {method} or at {email} to set up your trial first.",
  emailInstr: "We'll email {email} with {method} payment instructions.",
  keyAppears: 'Your licence key appears in My Account as soon as payment is confirmed.',
  lineActive: 'Your line is activated as soon as payment is confirmed.',
  lineActiveKeys: 'Your line is activated as soon as payment is confirmed and your {name} keys appear in My Account.',
  viewOrder: 'View my order',
  backAccount: 'Back to My account',
  notAvail: "That product isn't available",
  notAvailP: 'It may be paused or no longer sold. Pick a plan instead.',

  orderRequest: 'Order request',
  nothingCharged: 'Nothing is charged here. We email payment instructions, then switch your line on.',
  yourPackage: 'Your package',
  plan: 'Plan',
  simConn: 'Simultaneous connections',
  inclEpg: 'Includes the premium TV guide (EPG).',
  upTerm: 'Switch to {term} and save {amount}',
  upTermD: '{per}/mo instead of {was}/mo',
  upEpg: 'adds the TV guide (EPG)',
  upConn: 'Add a connection for +{amount}',
  upConnD: '{count} screens streaming at the same time',
  addTelly: 'Add {name} · {price} each',
  tellyHint: 'A lifetime player licence, paid once. Active on one device at a time.',
  reach: 'How to reach you',
  fullName: 'Full name',
  emailPay: 'Email for payment instructions',
  oneMore: 'One more way to reach you',
  handleLbl: '{method} handle',
  payMethod: 'Payment method',
  devicesOpt: "Devices you'll install it on (optional)",
  mainDevice: 'Main device (optional)',
  devicePh: 'Firestick, Smart TV, phone…',
  twoQ: 'Two quick questions',
  adultQ: 'Include adult content?',
  confirm18: 'I confirm I am 18 or older',
  trialQ: 'Want a free trial before paying?',
  trialNote: "We'll reach out with trial details before sending an invoice.",
  anything: 'Anything else',
  notes: 'Notes (optional)',
  notesPh: 'Two TVs in different rooms, prefer evening contact…',
  discount: 'Discount code (optional)',
  notValid: 'not valid for this plan',
  remove: 'Remove',
  apply: 'Apply',
  checkingL: 'Checking…',
  refQ: 'Referred by a friend? (optional)',
  refPh: "Your friend's Ghost Cable username",
  check: 'Check',
  refShort: 'Referrals only count on 6 months or longer. Pick a longer term so your friend earns their free month.',
  refHint: 'Must be an active, paid account. Your friend earns a free month when you order 6 months or longer.',
  summary: 'Summary',
  connN: '{count} connections',
  notSold: 'Not sold',
  codeLine: 'Code {code}',
  total: 'Total',
  accept: 'I understand these are digital products and all sales are final. Technical problems are handled through support.',
  seeThe: 'See the',
  refundPolicy: 'refund policy',
  termsL: 'terms',
  and: 'and',
  privacyL: 'privacy policy',
  offers: 'Send me occasional offers and new-channel news.',
  optional: 'Optional, unsubscribe any time.',
  sendOrder: 'Send order request',
  paidBy: 'Paid manually by {method}. No card is stored here.',
  lifetime: 'Lifetime licence',
  crypto: 'Crypto',
  etransfer: 'E-Transfer (CAD)',

  vSendFail: 'Could not send a code. Try again in a minute.',
  vSent: 'Code sent to {email}',
  vEnter: 'Enter the 6-digit code from the email.',
  vBad: 'That code did not work. Check it or send a new one.',
  vDone: 'Email verified',
  vHintOpt: 'Optional. We email you a 6-digit code so we know this inbox reaches you.',
  vHintOk: 'Confirmed. We can reach you here with confidence.',
  vHintSignIn: 'Sign in to verify your email. Optional.',
  vHintOnly: 'Only your account email ({email}) can be verified. Optional.',
  vLabel: 'Verified Email',
  vSend: 'Send code',
  vTitle: 'Verify your email',
  vDesc: 'Enter the 6-digit code we sent to {email}.',
  vVerify: 'Verify',
  vVerifying: 'Verifying…',
  vCode: 'Verification code',
  vNoEmail: 'No email?',
  vNew: 'Send a new code',

  methods: 'Card, Wise, Crypto or E-Transfer',
  inlineBold: 'No payment is taken here.',
  inlineText:
    'Payment is manual to guard against abuse and processor shutdowns. After your order is taken, you get a payment link once it is reviewed during working hours. You pay by {methods}. No card details are entered or stored on this site.',
  dlgTitle: 'Why payment is done by hand',
  dlgDesc: 'Manual payment keeps the service safe from abuse and keeps our payment processor from being shut down.',
  pt1: 'Why payment is manual',
  pd1: 'Every order is checked by hand. This guards against abuse and fraud, which can get a payment processor account shut down.',
  pt2: 'Why we ask for account info',
  pd2: 'Your account details let us confirm a real customer is behind each order before any payment is set up.',
  pt3: 'Your payment link',
  pd3: 'After your order is taken, you get a payment link once it is reviewed during working hours. You can pay by {methods}.',
  pt4: 'Nothing is charged here',
  pd4: 'No card details are entered or stored on this site.',
  gotIt: 'Got it',

  howPay: 'How to pay by {method}',
  amount: 'Amount',
  payTo: 'Pay to',
  reference: 'Reference',
  copy: 'Copy',
  putRef: 'Put {ref} in the payment note so we can match it to your order.',
  openLink: 'Open payment link',

  lookup: 'Order lookup',
  checkYour: 'Check your {order}',
  orderWord: 'order.',
  lookupIntro: "Order numbers start with {gc} followed by six letters or numbers. You'll find it on your confirmation screen and in our emails.",
  orderNumber: 'Order number',
  checkOrder: 'Check order',
  invalid: "That doesn't look like an order number. It should look like GC-7K2QXM.",
  signInSee: 'Sign in to see {code}',
  signInP: "Orders hold your line details, so we only show them to the account that placed them. Sign in with the email you ordered with and we'll open it straight away.",
  signInOpen: 'Sign in and open order',
  contactInstead: 'Contact us instead',
  noOrder: 'No order {code} on this account',
  missingP: 'Check the number on your confirmation, or sign in with the email you ordered with. Still stuck?',
  lookupErr: 'Could not check that order right now. Try again in a moment.',
  openMine: 'We open the order straight away if it belongs to your account.',
  askSignIn: "You'll be asked to sign in with the email you ordered with.",
};
